<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  computed: {
      ...mapState(['goEasy']),
  },
  mounted(){
      this.userInfo=this.$common.getStorage('userInfo');
      if(this.userInfo!=null&&this.$store.state.goEasy==null){
          this.$ajax.post(this.$domain.getOtp,{})
          .then(ret=>{
              if(ret.code=='200'){
                  this.$common.getConsole('app.vue——获取appKey加密',ret)
                  if(this.$store.state.goEasy==null){
                      let goEasy= new GoEasy({
                          appkey: "PC-e4edeab299364f30b605faa03f5c266d",
                          otp:ret.data
                      });
                      this.$store.state.goEasy=goEasy;
                  }
              }
          })
      }
  }
}
</script>

<style>
body{
  margin:0;
  padding:0;
  width:100%;
  height:100%;
}
html{
  margin:0;
  padding:0;
  width:100%;
  height:100%;
}
#app {
  position: absolute;
  top:0;
  bottom:0;
  width:100%;
  /* background-color: #000; */
}
.el-icon-loading{
  font-size: 70px;
}
.el-loading-spinner .el-loading-text{
  font-size: 34px !important;
}
.el-table .warning-color {
	    background: #e9fff6!important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue